import { Card, Text } from "@fluentui/react-components";
import { SquareFilled } from "@fluentui/react-icons";
import { useAtom, useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { darkModeAtom, selectedFullThemeAtom } from "store";
import styled from "styled-components";
import { darkStyledTheme, styledTheme } from "theme";
import { EThemeName, IStyledTheme } from "theme/types";

import { Flex } from "components/styled";

import { ColorPickerFluent } from "./ColorPickerFluent/ColorPickerFluent";

export function ThemeSelector() {
  const { t } = useTranslation();
  const darkMode = useAtomValue(darkModeAtom);
  const mainTheme = darkMode ? darkStyledTheme : styledTheme;

  const [selectedFullTheme, setSelectedFullTheme] = useAtom(selectedFullThemeAtom);

  const theme = (darkMode ? selectedFullTheme?.dark : selectedFullTheme?.light) as IStyledTheme;

  return (
    <Container>
      <Card
        style={{
          width: "100%",
        }}
      >
        <Flex $gap={"10px"}>
          <Text>{t("hbh.defaultTheme.label")}</Text>
          <Wrap selectedColor={theme.name === EThemeName.main ? theme.palette.purpleDark : ""}>
            <SquareFilled
              onClick={() => {
                setSelectedFullTheme({
                  light: styledTheme,
                  dark: darkStyledTheme,
                });
              }}
              style={{
                color: mainTheme.palette.purpleDark,
                width: "30px",
                height: "30px",
              }}
              className="icon"
            />
          </Wrap>
        </Flex>
        <Flex direction="column" align="flex-start">
          <Text>{t("hbh.generateOwnTheme.label")}</Text>

          <ColorPickerFluent />
        </Flex>
      </Card>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const Wrap = styled.div<{ selectedColor?: string }>`
  border: ${({ theme, selectedColor }) =>
    selectedColor ? `2px solid ${selectedColor}` : `1px solid ${theme.palette.neutralLight}`};
  cursor: pointer;
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.palette.white};
  border-radius: 4px;

  @keyframes shine {
    from {
      -webkit-mask-position: 150%;
    }

    to {
      -webkit-mask-position: -50%;
    }
  }

  .icon {
    -webkit-mask-image: linear-gradient(
      -75deg,
      rgba(0, 0, 0, 0.6) 30%,
      #000 50%,
      rgba(0, 0, 0, 0.6) 70%
    );
    -webkit-mask-size: 200%;
    animation: shine 2s infinite;
  }
`;
